import axios from 'axios';

/**
 * Creates a user
 * @param {Object} userData - the user data object
 * @returns {Promise} a promise of user to be created.
 */
export function registerUser(userData) {
	return axios.post('/v1/register', userData);
}

/**
 * Logs in a User
 * @param {Object} userData - user's email and password
 * @returns {Promise} response - promise of user to be logged in
 */
export function loginUser(userData) {
	return axios.post('/v1/login', userData);
}

/**
 * Logs in a User
 * @param {Object} userData - user's email 
 * @returns {Promise} response - promise of user email to be reset
 */
export function resetPassword(email) {
	return axios.post('/v1/password', email);
}

/**
 * Chage User password
 * @param {Object} password - user's password 
 * @returns {Promise} response - promise of changed password
 */
export function changePassword(password) {
	return axios.post('/v1/password/change', password);
}

/**
 * Fetches list of states
 * @returns {Promise} user - a promise of user to be resolved.
 */
export function getStates() {
	return axios.get('/v1/states?limit=37');
}

/**
 * Fetches list of cities under a state
 * @param {Number} id - id of a state
 * @returns {Promise} user - a promise of user to be resolved.
 */
export function getCities(id) {
	return axios.get(`/v1/states/${id}/cities`);
}